import {Directive, HostListener, Input} from '@angular/core';

@Directive({
  selector: '[appFloatNumber]',
})
export class FloatNumberTypeDirective {

  @Input() appFloatNumber: number;
  @Input() isPeakFlow: string;

  constructor() {
  }

  @HostListener('keypress', ['$event']) onKeyPress(event) {
    const charCode = event.key;
    this.appFloatNumber = Number(this.appFloatNumber);
    let numberRegex;
    if (this.isPeakFlow === 'true') {
      numberRegex = new RegExp(`^[0-9\,]+$`);
    } else {
      numberRegex = new RegExp(`^[0-9\.,]+$`);
    }
    if (!numberRegex.test(charCode)) {
      event.preventDefault();
    } else if ((charCode === '.' || charCode === ',')
      && (event.target.value.indexOf('.') >= 0 || event.target.value.indexOf(',') >= 0)) {
      event.preventDefault();
    } else if (event.target.value.indexOf('.') >= 0
      && (event.target.value.length - 1 - event.target.value.indexOf('.') === +this.appFloatNumber)) {
      event.preventDefault();
    } else if (event.target.value.indexOf(',') >= 0
      && (event.target.value.length - 1 - event.target.value.indexOf(',') === +this.appFloatNumber)) {
      event.preventDefault();
    }
    return true;
  }
}
